"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

require("regenerator-runtime/runtime");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jakte_plugin_1 = require("@drawbotics/jakte-plugin");

var superagent_1 = __importDefault(require("superagent"));

var utils_1 = require("./utils");

var JaktePluginLeads = function () {
  var JaktePluginLeads = /*#__PURE__*/function (_jakte_plugin_1$Jakte) {
    _inherits(JaktePluginLeads, _jakte_plugin_1$Jakte);

    var _super = _createSuper(JaktePluginLeads);

    function JaktePluginLeads() {
      _classCallCheck(this, JaktePluginLeads);

      return _super.apply(this, arguments);
    }

    _createClass(JaktePluginLeads, [{
      key: "captureLead",
      value: function () {
        var _captureLead = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(lead) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(this.config.url == null)) {
                    _context.next = 2;
                    break;
                  }

                  throw new Error('No url configured in "jakte-plugin-leads"');

                case 2:
                  if (!(this.Jakte.projectId == null)) {
                    _context.next = 4;
                    break;
                  }

                  throw new Error('No projectId defined when setting up Jakte');

                case 4:
                  if (!(this.Jakte.source == null)) {
                    _context.next = 6;
                    break;
                  }

                  throw new Error('No source defined when setting up Jakte');

                case 6:
                  _context.next = 8;
                  return superagent_1.default.post(this.config.url).send(utils_1.leadToServer(lead, this.Jakte.source, this.Jakte.projectId));

                case 8:
                  this.Jakte.setUser(lead.email, lead);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function captureLead(_x) {
          return _captureLead.apply(this, arguments);
        }

        return captureLead;
      }()
    }]);

    return JaktePluginLeads;
  }(jakte_plugin_1.JaktePlugin);

  JaktePluginLeads.key = 'leads';
  return JaktePluginLeads;
}();

exports.default = JaktePluginLeads;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-plugin-leads/lib/index.js
// module id = 821
// module chunks = 0